export default __webpack_public_path__ + "static/media/footer-bg.6382f168.png";